import { Component, Input } from '@angular/core';
import { TOOLTIP } from 'src/app/core/constants/tooltip.constants';
import { RoleArtifact } from 'src/app/core/models/role-artifacts.model';
import { DialogService } from 'src/app/core/services/dailog.service';

@Component({
  selector: 'app-app-progress',
  templateUrl: './app-progress.component.html',
  styleUrls: ['./app-progress.component.scss']
})
export class AppProgressComponent {
  @Input() roleArtifacts: RoleArtifact[] = [];

  outstanding = 0;
  completed = 0;
  total = 0;
  percent = 0;
  tooltipText = "";

  constructor(public dialogService:DialogService){}

  ngOnChanges(){
    this.calculate();
  }

  calculate(){
    this.roleArtifacts.map(i=>{
      this.outstanding += i.outstanding;
      this.completed += i.completed;
    })
    this.total = this.outstanding + this.completed;
    this.percent = Math.ceil(this.completed * 100 / this.total);
    this.tooltipText = TOOLTIP.appProgress(this.completed, this.outstanding);
  }

  openDialog(){
    this.dialogService.appProgress(this.roleArtifacts);
  }
}
